import styles from './Texto.module.css';

const Texto = ({ children, centralizado }: Readonly<{
    children: React.ReactNode;
    centralizado?: boolean;
}>) => {
    return <div className={[styles.container, centralizado ? styles.centralizado : null].join (' ')}>{children}</div>
}

export default Texto;